import Vue from 'vue'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'

//Components
import Alert from './Alert.vue'
import Buttons from './Buttons.vue'
import Badges from './Badges.vue'
import AnimateNumber from './AnimateNumber.vue'
import Tables from './tables/Tables.vue'

//Progress Bars
import ProgressBars from './ProgressBars.vue'
import BootstrapProgressBar from './progressbar/BootstrapProgressBar.vue'
import VueProgress from './progressbar/VueProgress.vue'

//import Tabs from './Tabs.vue'


//Importing Custom Components
import SidebarCollapse from './sidebar/SidebarCollapse.vue';
import CardTemplate from './widgets/CardTemplate.vue'

// Pages

//Custom Components
import Goback from './Goback.vue'
import Download from './Download.vue'
import McFilter from './McFilter.vue'
import Filters from './Filters.vue'
import FiltersMrkt from './FiltersMrkt.vue'
import Pagination from './pagination.vue'
// Vue.use(Goback);
Vue.component( 'goback', Goback)
Vue.component( 'download', Download)
Vue.component( 'mcfilter', McFilter)
Vue.component( 'filters', Filters)
Vue.component( 'filtersMrkt', FiltersMrkt)
Vue.component( 'pagination', Pagination)
// Table
import Vuetable from 'vuetable-2'
Vue.use(Vuetable)



// Registered Components
Vue.component( 'basix-alert', Alert)
Vue.component( 'sidebar-collapse', SidebarCollapse )
Vue.component( 'card', CardTemplate )
Vue.component( 'v-select', vSelect )
Vue.component( 'v-multiselect', Multiselect )
Vue.component( 'basix-counter', AnimateNumber )
Vue.component( 'bootstrap-progress-bar', BootstrapProgressBar )
Vue.component( 'vue-progressbar', VueProgress )
Vue.component( 'vuetable-pagination', Vuetable.VuetablePagination )


export {
  Alert,
  SidebarCollapse,
  CardTemplate,
  AnimateNumber,
  ProgressBars,
  BootstrapProgressBar,
  VueProgress,
  Tables,
  Goback,
  Download
}



// WEBPACK FOOTER //
// ./src/components/index.js